import React from 'react';
import styles from './PinkButton.module.scss';

interface TProps {
	onClick: () => void;
	ariaExpanded?: boolean;
	controlsId?: string;
	text: string;
	Icon: React.ElementType<React.SVGProps<unknown>>;
	classes?: {
		buttonClass?: string;
		icon?: string;
	};
	onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
	onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
}
export const PinkButton = React.forwardRef<HTMLButtonElement, TProps>(
	(
		{
			onClick,
			ariaExpanded,
			controlsId,
			text,
			Icon,
			classes,
			onMouseEnter,
			onMouseLeave,
			...rest
		},
		ref,
	) => {
		return (
			<button
				type='button'
				ref={ref}
				className={`${styles['button']} ${classes?.buttonClass} ${
					ariaExpanded ? styles['button_open'] : ''
				}`}
				onClick={onClick}
				aria-expanded={ariaExpanded ?? false}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				{...rest}
				{...(controlsId ? { 'aria-controls': controlsId } : {})}
			>
				<span className={styles['button__text']}>{text}</span>
				<span className={styles['button__icon-wrapper']}>
					<Icon
						className={`${styles['button__icon']} ${classes?.icon} ${
							ariaExpanded ? styles['button__icon_open'] : ''
						}`}
					/>
				</span>
			</button>
		);
	},
);

PinkButton.displayName = 'PinkButton';
